import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { PaymentChannelEnum } from '../enums/payment-channel.enum';
import { PaymentMethodEnum } from '../enums/payment-method.enum';
import { PaymentProviderEnum } from '../enums/payment-provider.enum';

/**
 * Payments filters
 */
export class PaymentsFilters extends ApiRequestFilters {
	/**
	 * Amount from
	 */
	@TransformFloat()
	amountFrom?: number;

	/**
	 * Amount to
	 */
	@TransformFloat()
	amountTo?: number;

	/**
	 * Payment method values
	 */
	paymentMethods?: PaymentMethodEnum[];

	/**
	 * Payment provider values
	 */
	providers?: PaymentProviderEnum[];

	/**
	 * Payment channel values
	 */
	channels?: PaymentChannelEnum[];

	/**
	 * Transaction id values
	 */
	transactionIds?: number[];
}
